module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Priscilla Royal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Priscilla Royal grew up in British Columbia and earned a B.A. in World Literature at San Francisco State University, where she discovered the beauty of medieval literature. She is a theater fan as well as a reader of history, mystery, and fiction of lesser violence. When not hiding in the thirteenth century, she lives in Northern California and is a member of California Writers Club, Mystery Writers of America, and Sisters in Crime.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tvckYE/tc-custom/9781615951819.jpg?1731883537523",
      "alt": "This image is the cover for the book Justice For The Damned, Medieval Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Justice For The Damned, Medieval Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("It is May of 1272, and Prioress Eleanor of Tyndale, recovering from a near-fatal winter fever, journeys to Amesbury Priory to visit her aunt in time for the Feast of Saint Melor. Although Eleanor hopes to regain her strength in the midst of pleasant childhood memories, Death reveals a most troublesome fondness for her company. A ghost now haunts Amesbury. And when a man is decapitated near the river where the grim figure walks, Sister Beatrice, Eleanor's aunt and acting prioress of Amesbury, shows an uncharacteristic hesitancy about taking charge of any investigation. As others apparently fall victim to the vengeful ghost, Eleanor struggles to put a human face on the restless spirit, and Brother Thomas, pursuing a secret mission for the Church connected with the Priory's famous Psaltery, finds that his own demons have unexpectedly taken on a very human form....")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Poisoned Pen Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0